// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","Storefront":"_2fa7nh","fadeInFrames":"_2u0c_F"};